module.exports = "<app-header-nav></app-header-nav>\r\n<!-- begin::Body -->\r\n<router-outlet></router-outlet>\r\n<!-- end::Body -->\r\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/theme.component.html
// module id = ./src/app/theme/theme.component.html
// module chunks = main